import Vue from "vue";
import Router from "vue-router";
import store from "./store/index";

// Routes
import loginRoutes from "@/routes/login";
import dashboardRoutes from "@/routes/dashboard";
import instancesRoutes from "@/routes/instances";
import contractsRoutes from "@/routes/contracts";
import newsRoutes from "@/routes/news";

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        ...loginRoutes,
        // ...dashboardRoutes,
        ...instancesRoutes,
        ...contractsRoutes,
        ...newsRoutes
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

/* Global router guards */
router.beforeEach((to, from, next) => {
    const login = "login";
    const isloggedIn: Boolean = store.getters["authentication/isLoggedIn"];

    if (!isloggedIn && to.name !== login) {
        next({ name: login });
    } else if (isloggedIn && to.name === login) {
        next(false);
    } else {
        next();
    }
});

export default router;
